import { createElement } from 'react';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { IconBundleBlueprint } from '@backstage/plugin-app-react';
import { createToolkitIcon } from './ToolkitIcon';

const toolkitIconNames = [
  'alertmanager',
  'argo-workflows',
  'artifact-keeper',
  'flux',
  'grafana',
  'headlamp',
  'hubble',
  'keycloak',
  'kiali',
  'libredb',
  'policy-reporter',
  'prometheus',
  'seaweedfs',
  'seaweedfs-filer',
] as const;

const toolkitIcons = IconBundleBlueprint.make({
  name: 'toolkit',
  params: {
    icons: Object.fromEntries(
      toolkitIconNames.map(name => [
        name,
        createElement(createToolkitIcon(name)),
      ]),
    ),
  },
});

export const toolkitModule = createFrontendModule({
  pluginId: 'app',
  extensions: [toolkitIcons],
});
